import {NullErrorReporter} from './reporters/empty';
import {SentryErrorReporter} from './reporters/sentry';
import {BaseErrorReporterWrapper, ExtraData, Tags} from './reporters/BaseErrorReporterWrapper';
import {LogType} from '@gongxigames/framework/core/fragments/ConsoleLogger';

export type InitOptions = {
    buildType: string;
};

export class ErrorReporter {
    private reporter: BaseErrorReporterWrapper;
    // on pokerstats mobile sentry_activation is possible to be NaN and sentry is always enabled for all games
    // instead of using ?? operator, should be used || operator to avoid NaN as valid value
    private rate = window.RP_CONFIG?.sentry_activation || 0;

    constructor() {
        const constructor = this.getErrorReporter();

        this.reporter = new constructor();
        this.reporter.init();
    }

    public setTags(tags: Tags): void {
        this.reporter.setTags(tags);
    }

    public addExtraData(data: ExtraData): void {
        this.reporter.addExtraData(data);
    }

    public receiver(logType: LogType, logData: any[]): void {
        this.reporter.receiver(logType, logData);
    }

    public disable(): void {
        this.reporter.disable();
    }

    private getErrorReporter(): typeof NullErrorReporter {
        if (Math.random() > this.rate) {
            return NullErrorReporter;
        }

        return SentryErrorReporter;
    }
}
